<template>
  <span>
    <button
      @click="showModal"
      class="t-align-right t-bg-dodger-blue t-px-8 t-py-3"
    >
      <span class="t-text-base t-font-bold t-text-white">
        <span class="t-text-sm">+</span>
        New Asset
      </span>
    </button>
    <a-modal
      title="Add a new asset"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model :layout="form.layout" :model="form" v-bind="formItemLayout">
        <a-form-model-item label="Asset Name">
          <a-input v-model="form.assetName" placeholder="HiAce Van" />
        </a-form-model-item>
        <a-form-model-item label="Tracker ID">
          <a-input v-model="form.eroadWhereDeviceId" placeholder="300395" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </span>
</template>

<script>
export default {
  name: "LinkTrackToBusiness",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        layout: "horizontal",
        eroadWhereDeviceId: "",
        assetName: ""
      }
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      if (!this.form.eroadWhereDeviceId.match("[0-9]+")) {
        this.$swal({
          title: "Please enter a 6 digital tracker number.",
          type: "error"
        });
        return;
      }
      this.confirmLoading = true;
      axios
        .post("/send-freight/tracker/business", {
          eroad_where_device_id: this.form.eroadWhereDeviceId,
          asset_name: this.form.assetName
        })
        .then(response => {
          this.visible = false;
          this.success();
          this.form.eroadWhereDeviceId = "";
          this.form.assetName = "";
          this.$emit("trackerAdded");
        })
        .catch(error => {
          this.error(error.response.data);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    handleCancel(e) {
      this.visible = false;
    },
    success() {
      this.$success({
        title: "Success",
        content: "Freighthub has added the asset to your business."
      });
    },
    error(data) {
      let content = "";
      if (typeof data.errors.asset_name !== "undefined") {
        content += data.errors.asset_name[0] + "\n";
      }
      if (typeof data.errors.eroad_where_device_id !== "undefined") {
        content += data.errors.eroad_where_device_id[0] + "\n";
      }
      if (
        typeof data.errors.asset_name === "undefined" &&
        typeof data.errors.eroad_where_device_id === "undefined"
      ) {
        content = "Something went wrong, please contact freighthub support.";
      }
      this.$error({
        title: data.message === "undefined" ? "Error" : data.message,
        content: content
      });
    }
  },
  computed: {
    formItemLayout() {
      const { layout } = this.form;
      return layout === "horizontal"
        ? {
            labelCol: { span: 5 },
            wrapperCol: { span: 16 }
          }
        : {};
    }
  }
};
</script>

<style scoped></style>
